import { SiteDetailPage } from '@/pages/inspection/sites/SiteDetailPage';
import { createFileRoute } from '@tanstack/react-router';

function SiteDetailRoute() {
	const { siteId } = Route.useParams();
	return <SiteDetailPage siteId={siteId} />;
}

export const Route = createFileRoute('/_authenticated/_app/inspection/sites/$siteId')({
	component: SiteDetailRoute,
});
